// ============================================================
// Domain Branded Types — verhindert versehentliches Mischen
// von IDs, Geldbeträgen und Scores auf Typebene
// ============================================================

export type MitarbeiterID  = string & { readonly __brand: 'MitarbeiterID' };
export type MandantID      = string & { readonly __brand: 'MandantID' };
export type ArbeitsplatzID = string & { readonly __brand: 'ArbeitsplatzID' };
export type RechnungsNummer = string & { readonly __brand: 'RechnungsNummer' };
export type LeistungsID    = string & { readonly __brand: 'LeistungsID' };
export type AuditLogID     = number & { readonly __brand: 'AuditLogID' };

/** Ganzzahl in Eurocent — niemals Floats für Geldbeträge! */
export type EuroCents = number & { readonly __brand: 'EuroCents' };

/** 0–100 Konfidenz-Score für Smart-Matching */
export type ConfidenceScore = number & { readonly __brand: 'ConfidenceScore' };

// ── Konstruktoren (mit Runtime-Validation) ──────────────────

export function toMitarbeiterID(s: string): MitarbeiterID {
  if (!s.trim()) throw new Error('MitarbeiterID darf nicht leer sein');
  return s as MitarbeiterID;
}

export function toMandantID(s: string): MandantID {
  if (!s.trim()) throw new Error('MandantID darf nicht leer sein');
  return s as MandantID;
}

export function toArbeitsplatzID(s: string): ArbeitsplatzID {
  if (!s.trim()) throw new Error('ArbeitsplatzID darf nicht leer sein');
  return s as ArbeitsplatzID;
}

export function toRechnungsNummer(s: string): RechnungsNummer {
  if (!/^\d{4}-\d{4,6}$/.test(s)) {
    throw new Error(`Ungültiges RechnungsNummer-Format: ${s} (erwartet YYYY-XXXXXX)`);
  }
  return s as RechnungsNummer;
}

export function toLeistungsID(s: string): LeistungsID {
  if (!s.trim()) throw new Error('LeistungsID darf nicht leer sein');
  return s as LeistungsID;
}

export function toEuroCents(cents: number): EuroCents {
  if (!Number.isInteger(cents) || cents < 0) {
    throw new Error(`EuroCents muss eine nicht-negative Ganzzahl sein, war: ${cents}`);
  }
  return cents as EuroCents;
}

/** Hilfsfunktion: Euro-Float → EuroCents (rundet kaufmännisch) */
export function euroToEuroCents(euro: number): EuroCents {
  return toEuroCents(Math.round(euro * 100));
}

/** Hilfsfunktion: EuroCents → formatierter String z.B. "12,50 €" */
export function formatEuroCents(cents: EuroCents): string {
  return (cents / 100).toLocaleString('de-AT', {
    style: 'currency',
    currency: 'EUR',
  });
}

export function toConfidenceScore(n: number): ConfidenceScore {
  if (!Number.isInteger(n) || n < 0 || n > 100) {
    throw new Error(`ConfidenceScore muss Integer 0–100 sein, war: ${n}`);
  }
  return n as ConfidenceScore;
}
